export default __webpack_public_path__ + "static/media/How-we-succeed.b1ac4519.jpeg";